const STORY_VOLUME = {
  arrival: 0.45,
  memories: 0.5,
  peak: 0.55,
  blessing: 0.45,
  wish: 0.25,
} as const;

function clamp01(value: number) {
  return Math.min(1, Math.max(0, value));
}

function mix(from: number, to: number, progress: number) {
  return from + (to - from) * clamp01(progress);
}

export const soundtrackMix = {
  cinematic: 0.45,
  finale: 0.45,
  peak: 0.6,
} as const;

export function getStorySoundtrackVolume(progress: number) {
  const position = clamp01(progress);

  if (position < 0.18) {
    return mix(STORY_VOLUME.arrival, STORY_VOLUME.memories, position / 0.18);
  }

  if (position < 0.66) {
    return mix(STORY_VOLUME.memories, STORY_VOLUME.peak, (position - 0.18) / 0.48);
  }

  if (position < 0.84) {
    return mix(STORY_VOLUME.peak, STORY_VOLUME.blessing, (position - 0.66) / 0.18);
  }

  return mix(STORY_VOLUME.blessing, STORY_VOLUME.wish, (position - 0.84) / 0.16);
}
